import { parsePhoneNumberFromString } from "libphonenumber-js/core";
import metadata from "libphonenumber-js/metadata.full.json";

export const removePlusPhone = (phone) => {
    return phone ? phone.replace(/^\+/, "") : phone;
  };

  export const addPlusPhone = (phone) => {
    return phone && !phone.startsWith("+") ? `+${phone}` : phone;
};

/**
 * Parses a phone number, removes the plus, and returns an object with country code and phone number.
 */
export const formatParseFamilyPhone = (phone) => {
  if (!phone) return { callingCode: "", phoneNumber: "" };

  const parsedNumber = parsePhoneNumberFromString(phone, metadata);
  if (!parsedNumber) return { callingCode: "", phoneNumber: "" };

  return {
    callingCode: parsedNumber.countryCallingCode,
    phoneNumber: parsedNumber.nationalNumber,
  };
};

/**
 * Combines country code and phone number into a full phone number with a plus sign.
 */
export const formatCombineFamilyPhone = ({ callingCode, phoneNumber }) => {
  if (!callingCode || !phoneNumber) return "";

  return `+${callingCode}${phoneNumber}`;
};
